module.exports = __webpack_public_path__ + "static/media/amazon.43f6d3da.gif";